import React, { useEffect } from 'react';
import { CountDetailsInterfaceComplete } from './Interfaces';
import Logo from '../../images/posmodified3.png';
import { Col, Row } from 'antd';
import { Image } from 'antd';
import { useTranslation } from 'react-i18next';
import moment from 'moment';

interface CountListPrintProps {
    contentRef: React.RefObject<HTMLDivElement>;
    countsDetails: CountDetailsInterfaceComplete | null;
}

const CountListPrint: React.FC<CountListPrintProps> = ({ contentRef, countsDetails }) => {

    const { t } = useTranslation("common");

    useEffect(() => {
        const style = document.createElement('style');
        style.type = 'text/css';
        style.innerHTML = `
            .printContent {
                display: none;
            }

            @media print {
                .printContent {
                    display: block;
                }

                @page {
                    size: A4;
                    margin: 3%;
                }

                @page :first {
                    margin-top: 0;
                }

                @page :left {
                    margin-left: 3%;
                }

                @page :right {
                    margin-right: 3%;
                }

                body {
                    counter-reset: page;
                }

                header {
                    text-align: center;
                }

                header:before {
                    content: "Page " counter(page);
                    counter-increment: page;
                }
            }
        `;
        document.head.appendChild(style);

        return () => {
            document.head.removeChild(style);
        };
    }, []);

    return (
        <Row ref={contentRef} className='printContent' style={{ maxWidth: '800px', width: '100%' }}>
            {/* Start Header */}
            <Row style={{ display: 'flex', justifyContent: 'space-between', paddingTop: '1rem', paddingBottom: '1.5rem' }}>
                <Col>
                    <Image src={Logo} alt="Description of the image" width={200} />
                </Col>
                <Col>
                    <div style={{ fontSize: '12px' }}>Data Solutions & Digital Services</div>
                    <div style={{ fontSize: '12px' }}>Beirut, Lebanon</div>
                    <div style={{ fontSize: '12px' }}>info@ds2pro.com</div>
                    <div style={{ fontSize: '12px' }}>+961 3 764 787</div>
                </Col>
            </Row>
            {/* End Footer */}
            <hr style={{ color: 'black' }} />
            {/* Start Body */}
            <Row style={{ justifyContent: 'center', marginTop: '1rem' }}>
                <div style={{ textDecoration: 'underline', fontSize: '20px' }}>{countsDetails?.count.name}</div>
            </Row>
            <Row style={{ paddingTop: '1rem' }}>
                <Col style={{ display: 'flex', flexDirection: 'column' }}>
                    <div style={{ fontSize: '12px' }}><span style={{ fontWeight: 'bold' }}>Name: </span>{countsDetails?.count.user.fullName}</div>
                    <div style={{ fontSize: '12px' }}><span style={{ fontWeight: 'bold' }}>Type: </span>{countsDetails?.count.type}</div>
                    <div style={{ fontSize: '12px' }}><span style={{ fontWeight: 'bold' }}>Warehouse: </span>{countsDetails?.count.warehouse.name}</div>
                </Col>
                <Col style={{ marginLeft: 'auto', textAlign: 'right' }}>
                    <div style={{ fontSize: '12px' }}><span style={{ fontWeight: 'bold' }}>Print Date: </span>{moment().format('MM/DD/YYYY h:mm:ss')}</div>
                    <div style={{ fontSize: '12px' }}><span style={{ fontWeight: 'bold' }}>Count Date: </span>{countsDetails?.count.date}</div>
                </Col>
            </Row>
            <Row style={{ display: 'flex', justifyContent: 'center', paddingTop: '1rem' }}>
                <Col style={{ width: '100%' }}>
                    <table className='print' style={{ borderCollapse: 'collapse', width: '100%' }}>
                        <thead>
                            <tr>
                                <th style={{ border: '1px solid black', padding: '4px', textAlign: 'left', fontSize: '8px', width: '20%' }} className="table-header"><b>{t("category")}</b></th>
                                <th style={{ border: '1px solid black', padding: '4px', textAlign: 'left', fontSize: '8px', width: '30%' }} className="table-header">{t("name")}</th>
                                <th style={{ border: '1px solid black', padding: '4px', textAlign: 'left', fontSize: '8px', width: '10%' }} className="table-header">{t("in-stock")}</th>
                                <th style={{ border: '1px solid black', padding: '4px', textAlign: 'left', fontSize: '8px', width: '10%' }} className="table-header">{t("on-hand")}</th>
                                <th style={{ border: '1px solid black', padding: '4px', textAlign: 'left', fontSize: '8px', width: '10%' }} className="table-header">{t("difference")}</th>
                                <th style={{ border: '1px solid black', padding: '4px', textAlign: 'left', fontSize: '8px', width: '20%' }} className="table-header">{t("justification")}</th>
                            </tr>
                        </thead>
                        <tbody>
                            {countsDetails?.data.map((record) => (
                                <tr key={record.item.id}>
                                    <td style={{ border: '1px solid black', padding: '4px', fontSize: '8px' }}>{record.item.category.name}</td>
                                    <td style={{ border: '1px solid black', padding: '4px', fontSize: '8px' }}>{record.item.name}</td>
                                    <td style={{ border: '1px solid black', padding: '4px', fontSize: '8px' }}>{record.quantityInStock ?? '0'}</td>
                                    <td style={{ border: '1px solid black', padding: '4px', fontSize: '8px' }}>{record.quantityOnHand}</td>
                                    <td style={{ border: '1px solid black', padding: '4px', fontSize: '8px' }}>{record.difference ?? '0'}</td>
                                    <td style={{ border: '1px solid black', padding: '4px', fontSize: '8px' }}>{record.justification?.name}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </Col>
            </Row>
            {/* End Body */}
            {/* Start Footer */}
            {/* <hr style={{ color: 'black', marginTop: '5rem', marginBottom: '1rem' }} />
            <Row style={{ display: 'flex', justifyContent: 'space-between', paddingBottom: '1rem', padding: '1rem' }}>
                <Col>
                    <Image src={Logo} alt="Description of the image" width={150} />
                </Col>
                <Col style={{ textAlign: 'center' }}>
                    <div style={{ fontSize: '8px' }}>Data Solutions & Digital Services</div>
                    <div style={{ fontSize: '8px' }}>www.ds2pro.com</div>
                </Col>
            </Row> */}
            {/* End Footer */}
        </Row>
    );
};

export default CountListPrint;
